module.exports = __webpack_public_path__ + "static/media/lips.b79c5d38.svg";